export default "__VITE_ASSET__BFDyHupL__"